/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var grammarDesc = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,9],$V1=[1,10],$V2=[6,20],$V3=[2,7],$V4=[1,19],$V5=[6,11,12,20],$V6=[1,25],$V7=[1,26],$V8=[1,27],$V9=[11,12],$Va=[2,25],$Vb=[16,19],$Vc=[2,32],$Vd=[2,25,28],$Ve=[2,16,19,33];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"ini":3,"CUERPO":4,"LISTA_OBJETO":5,"EOF":6,"ETIQUETACONFIGURACION":7,"OBJETO":8,"SUB_LISTA_OBJETO":9,"OBJETOGENERAL":10,"Texto":11,"InicioEtiquetaI":12,"SUB_OBJETOGENERAL":13,"LISTA_ATRIBUTOS":14,"CIERRE_ETIQUETAINICIO":15,"CierreEtiquetaI":16,"LISTA_OBJETO_Epsilon":17,"ETIQUETACIERRE":18,"FinEtiquetaI":19,"InicioEtiquetaC":20,"CierreEtiquetaC":21,"InicioEtiquetaConf":22,"SUB_ETIQUETACONFIG":23,"LISTA_ATRIBUTOSCONF":24,"CierreEtiquetaConf":25,"ATRIBUTOCONF":26,"SUB_LISTA_ATRIBUTOSCONF":27,"AtributoConf":28,"IgualAtributoConf":29,"ValorAtributoConf":30,"ATRIBUTO":31,"SUB_LISTA_ATRIBUTOS":32,"AtributoEtiqueta":33,"IgualAtributo":34,"ValorAtributo":35,"$accept":0,"$end":1},
terminals_: {2:"error",6:"EOF",11:"Texto",12:"InicioEtiquetaI",16:"CierreEtiquetaI",19:"FinEtiquetaI",20:"InicioEtiquetaC",21:"CierreEtiquetaC",22:"InicioEtiquetaConf",25:"CierreEtiquetaConf",28:"AtributoConf",29:"IgualAtributoConf",30:"ValorAtributoConf",33:"AtributoEtiqueta",34:"IgualAtributo",35:"ValorAtributo"},
productions_: [0,[3,1],[3,1],[4,2],[4,3],[5,2],[9,2],[9,0],[8,1],[8,1],[10,2],[13,2],[13,1],[13,2],[15,3],[15,1],[18,2],[17,1],[17,0],[7,2],[23,2],[23,1],[24,2],[24,2],[27,2],[27,0],[27,2],[26,3],[26,2],[14,2],[14,2],[32,2],[32,0],[32,2],[31,3],[31,2]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

    this.$=$$[$0]; grafo.generarPadre(1, "INICIO");grafo.generarHijos("INICIO");
    var retornoErrores = Object.assign([], ListaErrores);
    ListaErrores = [];
    var retornoGrafo = Object.assign({}, grafo);
    grafo = new grafoCST();
    return {datos:$$[$0],nodes:retornoGrafo.pilaNodos,edges:retornoGrafo.PilaEdges,tabla:retornoGrafo.TablaGramatica,errores:retornoErrores}
  
break;
case 2:

      ListaErrores.push({Error:'Error sintactico irrecuperable',tipo:"Semantico", Linea: this._$.first_line , columna: this._$.first_column}) 
      var retornoErrores = Object.assign([], ListaErrores);
      ListaErrores = [];
      var retornoGrafo = Object.assign({}, grafo);
      grafo = new grafoCST();
      return {datos:[],edges:[],nodes:[], tabla:[], errores:ListaErrores}
    
break;
case 3:
 
    this.$ = new helpers.Objeto("/",[],$$[$0-1],this._$.first_line, this._$.first_column);  
    grafo.generarPadre(1, "LISTA_OBJETO");
    grafo.generarHijos("LISTA_OBJETO");
    grafo.generarTexto("Cuerpo.entorno = ListaObjeto.entorno")
    
break;
case 4:
 this.$ = new helpers.Objeto("/",$$[$0-2],$$[$0-1],this._$.first_line, this._$.first_column); 
    grafo.generarPadre(2, "LISTA_OBJETO");
    grafo.generarPadre(1, "ETIQUETACONFIGURACION");
    grafo.generarHijos("ETIQUETACONFIGURACION","LISTA_OBJETO")
    grafo.generarTexto("Cuerpo.configs = EtiquetaConfigs.configs; Cuerpo.entorno = ListaObjeto.entorno");
  
break;
case 5:
 
    if ($$[$0-1].esTexto) { this.$ = $$[$0-1].texto } else { this.$=$$[$0]; this.$.push($$[$0-1].texto); this.$.reverse(); }
    grafo.generarPadre(2, "SUB_LISTA_OBJETO");
    grafo.generarPadre(1, "OBJETO");
    grafo.generarHijos("OBJETO","SUB_LISTA_OBJETO");
    grafo.generarTexto(`Objeto.entorno.set(Objeto.val)`)
  
break;
case 6:
 
      if ($$[$0-1].esTexto) { this.$ = $$[$0-1].texto } else { this.$=$$[$0]; this.$.push($$[$0-1].texto); }
      grafo.generarPadre(2, "SUB_LISTA_OBJETO");
      grafo.generarPadre(1, "OBJETO");
      grafo.generarHijos("OBJETO","SUB_LISTA_OBJETO");
      grafo.generarTexto(`LostaObjeto.entorno.set(Objeto.val)`)
    
break;
case 7:
 
      this.$ = new Array(); 
      grafo.generarHijos("Ɛ");
      grafo.generarTexto(`ListaObjeto.entorno = new Entorno();`)
    
break;
case 8:
 
    this.$ = { texto:$$[$0], esTexto:false};
    grafo.generarPadre(1, "OBJETOGENERAL");
    grafo.generarHijos("OBJETOGENERAL");
    grafo.generarTexto("Objeto.val = ObjetoGeneral.val");
  
break;
case 9:
 
    this.$ = { texto:helpers.CambiarCodificacion($$[$0],tipoCodificacion), esTexto:true};
    grafo.generarHijos("Texto");
    grafo.generarTexto("Texto.val=texto")  
  
break;
case 10:
 
    $$[$0].linea=this._$.first_line; $$[$0].columna=this._$.first_column;
    this.$ = objetoCorrecto($$[$0-1], $$[$0],this._$.first_line, this._$.first_column)? $$[$0]:null;
    grafo.generarPadre(2, "SUB_OBJETOGENERAL");
    grafo.generarHijos($$[$0-1],"SUB_OBJETOGENERAL");
    grafo.generarTexto(`OBJETOGENERAL.valor = ${$$[$0-1]} + SUB_OBJETOGENERAL.valor;`);
  
break;
case 11:
 
      this.$=$$[$0]; this.$.atributos=$$[$0-1]; grafo.generarPadre(2, "CIERRE_ETIQUETAINICIO");
      grafo.generarPadre(1, "LISTA_ATRIBUTOS");
      grafo.generarHijos("LISTA_ATRIBUTOS","CIERRE_ETIQUETAINICIO");
      grafo.generarTexto("SUB_OBJETOGENERAL.entorno = LISTA_ATRIBUTOS.entorno; SUB_OBJETOGENERAL.valor = CIERRE_ETIQUETAINICIO.valor");
    
break;
case 12:
 
      this.$=$$[$0]; grafo.generarPadre(1, "CIERRE_ETIQUETAINICIO");
      grafo.generarHijos("CIERRE_ETIQUETAINICIO");
      grafo.generarTexto(`SUB_OBJETOGENERAL.valor = CIERRE_ETIQUETAINICIO.valor;`);
    
break;
case 13:
 
      this.$=$$[$0-1]; 
      this.$.atributos=[]; 
      grafo.generarPadre(2, "CIERRE_ETIQUETAINICIO");
      grafo.generarHijos("error","CIERRE_ETIQUETAINICIO");
      grafo.generarTexto("SUB_OBJETOGENERAL.valor = CIERRE_ETIQUETAINICIO.valor; new Error();");
      ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column});
    
break;
case 14:
 
    this.$ = new helpers.Objeto("", [], $$[$0-1],0,0);
    this.$.setTipo($$[$0]);
    grafo.generarPadre(3, "ETIQUETACIERRE");
    grafo.generarPadre(2, "LISTA_OBJETO_Epsilon");
    grafo.generarHijos($$[$0-2],"LISTA_OBJETO_Epsilon","ETIQUETACIERRE");
    grafo.generarTexto(`CIERRE_ETIQUETAINICIO.valor = ">" + LISTA_OBJETO_Epsilon.valor;`);
    
break;
case 15:
 
    this.$ = new helpers.Objeto("",[], [],0,0);
    grafo.generarHijos($$[$0]);
    grafo.generarTexto(`CIERRE_ETIQUETAINICIO.valor = "/>";`);
  
break;
case 16:
 this.$ = $$[$0-1]; grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`EtiquetaCierre.nombre = ${$$[$0-1].replace("</","")}`) 
break;
case 17:
 
    this.$ = $$[$0]; grafo.generarPadre(1, "LISTA_OBJETO");
    grafo.generarHijos("LISTA_OBJETO");
    grafo.generarTexto("LISTA_OBJETO_Epsilon.valor = LISTA_OBJETO.Objetos");
  
break;
case 18:

    this.$ = []; grafo.generarHijos("Ɛ");
    grafo.generarTexto("LISTA_OBJETO_Epsilon.valor = [];");
  
break;
case 19:
 
    this.$ = $$[$0]; grafo.generarPadre(2, "SUB_ETIQUETACONFIG");
    grafo.generarHijos($$[$0-1],"SUB_ETIQUETACONFIG");
    grafo.generarTexto(`EtiquetaConfiguracion.configuraciones= SUB_ETIQUETACONFIG.valor`)
  
break;
case 20:
 
    this.$ = $$[$0-1]; grafo.generarPadre(1, "SUB_ETIQUETACONFIG");
    grafo.generarHijos("LISTA_ATRIBUTOSCONF",$$[$0]) 
    grafo.generarTexto(`SUB_ETIQUETACONFIG.valor = Lista_AtributosConf.configuraciones;`)
  
break;
case 21:
 
    this.$ = []; grafo.generarHijos($$[$0]) 
    grafo.generarTexto(`SUB_ETIQUETACONFIG.valor = [];`)
  
break;
case 22:
 
    this.$=$$[$0]; this.$.push($$[$0-1]);
    grafo.generarPadre(2, "SUB_LISTA_ATRIBUTOSCONF");
    grafo.generarPadre(1, "ATRIBUTOCONF");
    grafo.generarHijos("ATRIBUTOCONF","SUB_LISTA_ATRIBUTOSCONF") 
    grafo.generarTexto(`Lista_AtributoConf.configuraciones.push(AtributoConf.configuracion);`)
    
break;
case 23:
 
    this.$=[]; this.$.push($$[$0-1]);
    grafo.generarPadre(1, "ATRIBUTOCONF");
    grafo.generarHijos("ATRIBUTOCONF","error");
    grafo.generarTexto(`Lista_AtributoConf.configuraciones.push(AtributoConf.configuracion); new Error();`)
    ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column}); 
  
break;
case 24:

    this.$=$$[$0]; this.$.push($$[$0-1]);
    grafo.generarPadre(2, "SUB_LISTA_ATRIBUTOSCONF");
    grafo.generarPadre(1, "ATRIBUTOCONF");
    grafo.generarHijos("ATRIBUTOCONF","SUB_LISTA_ATRIBUTOSCONF");
    grafo.generarTexto(`Lista_AtributoConf.configuraciones.push(AtributoConf.configuracion);`)
    
break;
case 25:

    this.$ = []; grafo.generarHijos("Ɛ");
     grafo.generarTexto(`Lista_AtributoConf.configuraciones= [];`)
  
break;
case 26:
 
    this.$ = []; this.$.push($$[$0-1]); 
    grafo.generarPadre(1, "ATRIBUTOCONF");
    grafo.generarHijos("ATRIBUTOCONF","error");
    grafo.generarTexto(`Lista_AtributoConf.configuraciones.push(AtributoConf.configuracion); new Error();`)
    ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column}); 
  
break;
case 27:
 
    this.$ = new helpers.Atributo($$[$0-2],$$[$0],this._$.first_line, this._$.first_column); 
    grafo.generarHijos($$[$0-2],$$[$0-1],$$[$0]) 
    if ($$[$0-2] == 'encoding') tipoCodificacion = $$[$0]
    grafo.generarTexto(`AtributoConf.configuracion = new Configuracion(${$$[$0-2]},${$$[$0]},${this._$.first_line},${this._$.first_column})`)
  
break;
case 28:
 
    this.$ = []; this.$.push($$[$0-1]);
    grafo.generarHijos($$[$0-1],"error");
    grafo.generarTexto(`AtributoConf.configuracion = new Configuracion(${$$[$0-1]}); new Error();`)
    ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column});   
    
break;
case 29:
 
    this.$ = $$[$0]; this.$.push($$[$0-1]);
    grafo.generarPadre(2,"ATRIBUTO");
    grafo.generarPadre(1,"SUB_LISTA_ATRIBUTOS");
    grafo.generarHijos("ATRIBUTO","SUB_LISTA_ATRIBUTOS");
    grafo.generarTexto(`Lista_Atributos.entorno.set(Atributo.valor);`)
  
break;
case 30:
 
    this.$ = []; this.$.push($$[$0-1]);
    grafo.generarPadre(1,"ATRIBUTO");
    grafo.generarHijos("ATRIBUTO","error"); 
    grafo.generarTexto(`Lista_Atributos.entorno.set(Atributo.valor); new Error();`)
    ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column});
  
break;
case 31:

    this.$ = $$[$0]; this.$.push($$[$0-1]);
    grafo.generarPadre(2, "SUB_LISTA_ATRIBUTOS");
    grafo.generarPadre(1, "ATRIBUTO");
    grafo.generarHijos("ATRIBUTO","SUB_LISTA_ATRIBUTOS")
    grafo.generarTexto(`Lista_Atributos.entorno.set(Atributo.valor);`)
  
break;
case 32:
 
    this.$ = []; grafo.generarHijos("Ɛ");
    grafo.generarTexto(`Lista_Atributos.entorno = new Entorno("Atributos");`)
  
break;
case 33:
 
    this.$ = []; this.$.push($$[$0-1]);
    grafo.generarPadre(1, "ATRIBUTO");
    grafo.generarHijos("ATRIBUTO","error");
    grafo.generarTexto(`Lista_Atributos.entorno.set(Atributo.valor); new Error();`)
    ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column});  
  
break;
case 34:

    this.$ = new helpers.Atributo($$[$0-2],$$[$0],this._$.first_line, this._$.first_column);
    grafo.generarHijos($$[$0-2],$$[$0-1],$$[$0])
    grafo.generarTexto(`Atributo.valor = new Atributo(${$$[$0-2]},${$$[$0]},${this._$.first_line},${this._$.first_column})`)
  
break;
case 35:
 
    this.$ = null; 
    grafo.generarHijos($$[$0-1],"error"); 
    grafo.generarTexto(`new Error()`)
    ListaErrores.push({Error:'Error sintactico recuperado en ' + yytext ,tipo:"Sintáctico", Linea: this._$.first_line , columna: this._$.first_column});
  
break;
}
},
table: [{2:[1,3],3:1,4:2,5:4,7:5,8:6,10:8,11:$V0,12:$V1,22:[1,7]},{1:[3]},{1:[2,1]},{1:[2,2]},{6:[1,11]},{5:12,8:6,10:8,11:$V0,12:$V1},o($V2,$V3,{10:8,9:13,8:14,11:$V0,12:$V1}),{23:15,24:16,25:[1,17],26:18,28:$V4},o($V5,[2,8]),o($V5,[2,9]),{2:[1,23],13:20,14:21,15:22,16:$V6,19:$V7,31:24,33:$V8},{1:[2,3]},{6:[1,28]},o($V2,[2,5]),o($V2,$V3,{10:8,8:14,9:29,11:$V0,12:$V1}),o($V9,[2,19]),{25:[1,30]},o($V9,[2,21]),{2:[1,32],25:$Va,26:33,27:31,28:$V4},{2:[1,35],29:[1,34]},o($V5,[2,10]),{15:36,16:$V6,19:$V7},o($V5,[2,12]),{15:37,16:$V6,19:$V7},o($Vb,$Vc,{32:38,31:40,2:[1,39],33:$V8}),{5:42,8:6,10:8,11:$V0,12:$V1,17:41,20:[2,18]},o($V5,[2,15]),{2:[1,44],34:[1,43]},{1:[2,4]},o($V2,[2,6]),o($V9,[2,20]),{25:[2,22]},{25:[2,23]},{2:[1,46],25:$Va,26:33,27:45,28:$V4},{30:[1,47]},o($Vd,[2,28]),o($V5,[2,11]),o($V5,[2,13]),o($Vb,[2,29]),o($Vb,[2,30]),o($Vb,$Vc,{31:40,32:48,2:[1,49],33:$V8}),{18:50,20:[1,51]},{20:[2,17]},{35:[1,52]},o($Ve,[2,35]),{25:[2,24]},{25:[2,26]},o($Vd,[2,27]),o($Vb,[2,31]),o($Vb,[2,33]),o($V5,[2,14]),{21:[1,53]},o($Ve,[2,34]),o($V5,[2,16])],
defaultActions: {2:[2,1],3:[2,2],11:[2,3],28:[2,4],31:[2,22],32:[2,23],42:[2,17],45:[2,24],46:[2,26]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse (input) {
    var self = this,
        stack = [0],
        tstack = [], // token stack
        vstack = [null], // semantic value stack
        lstack = [], // location stack
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;

    var args = lstack.slice.call(arguments, 1);

    //this.reductionCount = this.shiftCount = 0;

    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    // copy state
    for (var k in this.yy) {
      if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
        sharedState.yy[k] = this.yy[k];
      }
    }

    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);

    var ranges = lexer.options && lexer.options.ranges;

    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }

    function popStack (n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }

_token_stack:
    var lex = function () {
        var token;
        token = lexer.lex() || EOF;
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }

    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        // retreive state number from top of stack
        state = stack[stack.length - 1];

        // use default actions if available
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            // read action for current state and first input
            action = table[state] && table[state][symbol];
        }

_handle_error:
        // handle parse error
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var error_rule_depth;
            var errStr = '';

            // Return the rule stack depth where the nearest error rule can be found.
            // Return FALSE when no error recovery rule was found.
            function locateNearestErrorRecoveryRule(state) {
                var stack_probe = stack.length - 1;
                var depth = 0;

                // try to recover from error
                for(;;) {
                    // check for error recovery rule in this state
                    if ((TERROR.toString()) in table[state]) {
                        return depth;
                    }
                    if (state === 0 || stack_probe < 2) {
                        return false; // No suitable error recovery rule available.
                    }
                    stack_probe -= 2; // popStack(1): [symbol, action]
                    state = stack[stack_probe];
                    ++depth;
                }
            }

            if (!recovering) {
                // first see if there's any chance at hitting an error recovery rule:
                error_rule_depth = locateNearestErrorRecoveryRule(state);

                // Report error
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push("'"+this.terminals_[p]+"'");
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol)+ "'";
                } else {
                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                  (symbol == EOF ? "end of input" :
                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected,
                    recoverable: (error_rule_depth !== false)
                });
            } else if (preErrorSymbol !== EOF) {
                error_rule_depth = locateNearestErrorRecoveryRule(state);
            }

            // just recovered from another error
            if (recovering == 3) {
                if (symbol === EOF || preErrorSymbol === EOF) {
                    throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
                }

                // discard current lookahead and grab another
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                symbol = lex();
            }

            // try to recover from error
            if (error_rule_depth === false) {
                throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
            }
            popStack(error_rule_depth);

            preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
            symbol = TERROR;         // insert generic error symbol as new lookahead
            state = stack[stack.length-1];
            action = table[state] && table[state][TERROR];
            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
        }

        // this shouldn't happen, unless resolve defaults are off
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
        }

        switch (action[0]) {
            case 1: // shift
                //this.shiftCount++;

                stack.push(symbol);
                vstack.push(lexer.yytext);
                lstack.push(lexer.yylloc);
                stack.push(action[1]); // push state
                symbol = null;
                if (!preErrorSymbol) { // normal execution/no error
                    yyleng = lexer.yyleng;
                    yytext = lexer.yytext;
                    yylineno = lexer.yylineno;
                    yyloc = lexer.yylloc;
                    if (recovering > 0) {
                        recovering--;
                    }
                } else {
                    // error just occurred, resume old lookahead f/ before error
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;

            case 2:
                // reduce
                //this.reductionCount++;

                len = this.productions_[action[1]][1];

                // perform semantic action
                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                // default location, uses first token for firsts, last for lasts
                yyval._$ = {
                    first_line: lstack[lstack.length-(len||1)].first_line,
                    last_line: lstack[lstack.length-1].last_line,
                    first_column: lstack[lstack.length-(len||1)].first_column,
                    last_column: lstack[lstack.length-1].last_column
                };
                if (ranges) {
                  yyval._$.range = [lstack[lstack.length-(len||1)].range[0], lstack[lstack.length-1].range[1]];
                }
                r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));

                if (typeof r !== 'undefined') {
                    return r;
                }

                // pop off stack
                if (len) {
                    stack = stack.slice(0,-1*len*2);
                    vstack = vstack.slice(0, -1*len);
                    lstack = lstack.slice(0, -1*len);
                }

                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                // goto new state = table[STATE][NONTERMINAL]
                newState = table[stack[stack.length-2]][stack[stack.length-1]];
                stack.push(newState);
                break;

            case 3:
                // accept
                return true;
        }

    }

    return true;
}};

	var helpers = require('../analizadorXML/helpers')
  const {grafoCST} = require('../CST')
  var grafo = new grafoCST(); 
	var atributosRaiz = []
	// Codificación global
  var tipoCodificacion = "utf8"

  function objetoCorrecto (inicio, fin, linea, columna){
    if(!inicio || fin==undefined)
    {
      return undefined
    }
		inicio = inicio.replace('<','')
    if(fin.tipo == ""){
      fin.tipo=inicio
      return inicio;
    }
		var tempfin = fin.tipo.replace('</','')
    if(inicio === tempfin){
      return inicio;
    }
    ListaErrores.push({Error:'Este es un error Semantico: Etiquetas no coinciden',tipo:"Semantico", Linea: linea , columna:columna})
		return undefined;
	}

  function ReemplazaTexto(texto)
  {
    if(!texto)
    {
      return texto
    }
    var result = texto.split("&lt;").join("<");
    result = result.split("&gt;").join(">");
    result = result.split("&amp;").join("&");
    result = result.split("&apos;").join("'");
    result = result.split("&quot;").join(`"`);
    return result
  }

  var ListaErrores = []

/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:
break;
case 1:
break;
case 2:this.begin("Etiquetai"); return 12
break;
case 3:this.begin("EtiquetaComentario"); 
break;
case 4:
break;
case 5:
break;
case 6:this.popState(); 
break;
case 7:
break;
case 8:
break;
case 9:
break;
case 10:
break;
case 11:
break;
case 12: return 33
break;
case 13: return 34
break;
case 14: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 35
break;
case 15: ListaErrores.push({Error:'Este es un error léxico: ' + yy_.yytext,tipo:"Lexico", Linea: yy_.yylloc.first_line , columna:yy_.yylloc.first_column}) 
break;
case 16: this.popState(); return 16
break;
case 17: this.popState(); return 19
break;
case 18: this.begin("Etiquetac"); return 20
break;
case 19:
break;
case 20:
break;
case 21: ListaErrores.push({Error:'Este es un error léxico: ' + yy_.yytext,tipo:"Lexico", Linea: yy_.yylloc.first_line , columna:yy_.yylloc.first_column}) 
break;
case 22: this.popState(); return 21
break;
case 23: this.begin("EtiquetaConf"); return 22
break;
case 24: return 28
break;
case 25: return 29
break;
case 26: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 30
break;
case 27:
break;
case 28: ListaErrores.push({Error:'Este es un error léxico: ' + yy_.yytext,tipo:"Lexico", Linea: yy_.yylloc.first_line , columna:yy_.yylloc.first_column}) 
break;
case 29: this.popState(); return 25
break;
case 30:return 6;
break;
case 31: yy_.yytext = ReemplazaTexto(yy_.yytext); return 11 
break;
case 32: ListaErrores.push({Error:'Este es un error léxico: ' + yy_.yytext,tipo:"Lexico", Linea: yy_.yylloc.first_line , columna:yy_.yylloc.first_column}) 
break;
}
},
rules: [/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:<[A-ZÑa-zñ_][A-ZÑa-zñ0-9_-]*)/i,/^(?:<!--)/i,/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:-->)/i,/^(?:-)/i,/^(?:>)/i,/^(?:[^-->]+)/i,/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:[A-ZÑa-zñ][A-ZÑa-zñ0-9_-]*)/i,/^(?:=)/i,/^(?:"[^\n\"]*")/i,/^(?:[^A-ZÑa-zñ_="/>]+)/i,/^(?:>)/i,/^(?:\/>)/i,/^(?:<\/[A-ZÑa-zñ_][A-ZÑa-zñ0-9_-]*)/i,/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:[^>]+)/i,/^(?:>)/i,/^(?:<\?[A-ZÑa-zñ_][A-ZÑa-zñ0-9_-]*)/i,/^(?:[A-ZÑa-zñ][A-ZÑa-zñ0-9_-]*)/i,/^(?:=)/i,/^(?:"[^\n\"]*")/i,/^(?:[ \r\t]+)/i,/^(?:[^A-ZÑa-zñ_="?>]+)/i,/^(?:\?>)/i,/^(?:$)/i,/^(?:[^<]+)/i,/^(?:.)/i],
conditions: {"EtiquetaComentario":{"rules":[4,5,6,7,8,9],"inclusive":false},"EtiquetaConf":{"rules":[24,25,26,27,28,29],"inclusive":false},"Etiquetac":{"rules":[19,20,21,22],"inclusive":false},"Etiquetai":{"rules":[10,11,12,13,14,15,16,17],"inclusive":false},"INITIAL":{"rules":[0,1,2,3,18,23,30,31,32],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = grammarDesc;
exports.Parser = grammarDesc.Parser;
exports.parse = function () { return grammarDesc.parse.apply(grammarDesc, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}